import { v4 as uuid } from 'uuid';

import { ReferralCreateData } from 'chaika-frontend-types/frontend-cms';

type IncludedServiceIdsLookup = (serviceId: string) => string[];

// A composite-priced service is never created as one referral: each chosen sub-service gets a referral of its own
export function expandCompositeReferrals(
    referrals: ReferralCreateData[],
    getIncludedServiceIds: IncludedServiceIdsLookup,
): ReferralCreateData[] {
    return referrals.flatMap(referral => {
        const includedServiceIds = getIncludedServiceIds(referral.serviceId);

        if (includedServiceIds.length === 0) {
            return [referral];
        }

        const { compositeServices, ...common } = referral;
        const subServices = compositeServices ?? includedServiceIds.map(id => ({ id, plans: [] }));

        return subServices.map(subService => ({
            ...common,
            id: uuid(),
            serviceId: subService.id,
            serviceParams: subService,
        }));
    });
}
